var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiHorrible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24C1.5 29.9674 3.87053 35.6903 8.0901 39.9099C12.3097 44.1295 18.0326 46.5 24 46.5C29.9674 46.5 35.6903 44.1295 39.9099 39.9099C44.1295 35.6903 46.5 29.9674 46.5 24C46.5 18.0326 44.1295 12.3097 39.9099 8.0901C35.6903 3.87053 29.9674 1.5 24 1.5C18.0326 1.5 12.3097 3.87053 8.0901 8.0901C3.87053 12.3097 1.5 18.0326 1.5 24V24Z",
    stroke: "#F72717",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.096 36C34.9789 33.7455 33.2541 31.848 31.1161 30.5213C28.9782 29.1947 26.5121 28.4917 23.996 28.4917C21.4799 28.4917 19.0138 29.1947 16.8759 30.5213C14.7379 31.848 13.0131 33.7455 11.896 36",
    stroke: "#F72717",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5L19.5 21",
    stroke: "#F72717",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 16.5L28.5 21",
    stroke: "#F72717",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiHorrible);
export default __webpack_public_path__ + "static/media/emoji-horrible.cb812191140ef383863554a2e5613612.svg";
export { ForwardRef as ReactComponent };